export default "__VITE_ASSET__BUPv91KE__"